module.exports = __webpack_public_path__ + "img/Deportes.d7cd91ed.svg";